import { render, staticRenderFns } from "./FormFooter.vue?vue&type=template&id=40186478&scoped=true"
import script from "./FormFooter.vue?vue&type=script&lang=js"
export * from "./FormFooter.vue?vue&type=script&lang=js"
import style0 from "./FormFooter.vue?vue&type=style&index=0&id=40186478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40186478",
  null
  
)

export default component.exports